module.exports = __webpack_public_path__ + "static/media/MGE.1d5eb2c4.png";